module.exports = __webpack_public_path__ + "img/b.7bb2224f.jpg";